var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1H7c.33 0 .71.05 1.07.15.35.1.76.27 1.1.55a3 3 0 0 1 1 1.86c.13.9.34 1.76.65 2.6a3 3 0 0 1-.67 3.16l-.72.72A15 15 0 0 0 14 14.63l.72-.72a3 3 0 0 1 3.17-.68c.83.31 1.7.53 2.59.65a3 3 0 0 1 1.88 1.03c.55.65.64 1.53.63 2.1v3.06c0 .22.02.6-.17 1.04a3 3 0 0 1-3.02 1.78h-.02a19.63 19.63 0 0 1-8.83-3.05 21.82 21.82 0 0 1-6.53-6.47 20.79 20.79 0 0 1-3.23-9.1v-.02a3 3 0 0 1 1.78-3.02c.28-.12.63-.17.84-.2L4.5 1ZM7 3H4.5a4.7 4.7 0 0 0-.73.07 1 1 0 0 0-.58 1 18.79 18.79 0 0 0 2.92 8.21v.01a19.82 19.82 0 0 0 5.93 5.87A17.63 17.63 0 0 0 20 20.9a1 1 0 0 0 1.01-.62 1.09 1.09 0 0 0 0-.17v-3.13c.01-.42-.08-.69-.16-.78a1 1 0 0 0-.62-.34 13.84 13.84 0 0 1-3.02-.75 1 1 0 0 0-1.06.22l-1.27 1.27a1 1 0 0 1-1.2.16 17 17 0 0 1-6.37-6.38 1 1 0 0 1 .16-1.2l1.27-1.27a1 1 0 0 0 .22-1.05c-.36-.98-.62-2-.75-3.03a1 1 0 0 0-.34-.61.96.96 0 0 0-.33-.15A1.93 1.93 0 0 0 7 3H7Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.8eba5abf09bb037e0049e3aab32478a5.svg";
export { ForwardRef as ReactComponent };